import React, { useState } from 'react';
import './TryTSU.css';

function TryTSU() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    business: '',
    location: '',
    type: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, you would submit this data to your backend
    alert('Thank you for your interest! We will contact you soon.');
    setFormData({
      name: '',
      email: '',
      business: '',
      location: '',
      type: '',
      message: ''
    });
  };

  return (
    <div className="try-tsu-page">
      {/* Hero Section */}
      <section className="try-hero">
        <div className="try-hero-overlay">
          <div className="container">
            <div className="try-hero-content">
              <div className="try-hero-badge">Try TSU</div>
              <h1 className="try-hero-title">Try TSU Your Way</h1>
              <p className="try-hero-subtitle">Experience Adaptive Fashion with Confidence</p>
              <p className="try-hero-text">
                Explore our collections through virtual consultations, digital lookbooks, and home try-on options.
              </p>
              <div className="try-hero-buttons">
                <a href="#virtual" className="try-hero-btn primary">Book Virtual Consultation</a>
                <a href="/shop" className="try-hero-btn secondary">Shop Online</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Virtual Try-On Section */}
      <section id="virtual" className="virtual-section">
        <div className="container">
          <div className="virtual-content">
            <div className="virtual-text">
              <h2>Try TSU From Home</h2>
              <p className="virtual-subtitle">Personalized guidance without leaving home</p>
              
              <div className="virtual-features">
                <div className="virtual-feature">
                  <div className="feature-icon">💻</div>
                  <div>
                    <h4>Video Consultation</h4>
                    <p>One-on-one virtual fittings with our experts</p>
                  </div>
                </div>
                
                <div className="virtual-feature">
                  <div className="feature-icon">📱</div>
                  <div>
                    <h4>Digital Lookbook</h4>
                    <p>Interactive product exploration</p>
                  </div>
                </div>
                
                <div className="virtual-feature">
                  <div className="feature-icon">📦</div>
                  <div>
                    <h4>Home Try-On</h4>
                    <p>Selected items shipped for you to try at home</p>
                  </div>
                </div>
              </div>
              
              <div className="virtual-cta">
                <a href="/virtual-try-on" className="virtual-btn">Book Virtual Consultation</a>
                <a href="/digital-lookbook" className="virtual-btn secondary">View Digital Lookbook</a>
              </div>
            </div>
            
            <div className="virtual-image">
              <img 
                src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
                alt="Virtual try-on consultation" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Become a Stockist Section */}
      <section className="stockist-section">
        <div className="container">
          <div className="section-header">
            <h2>Want to be a Stockist?</h2>
            <p className="section-subtitle">Join our partner network and bring adaptive fashion to your community</p>
          </div>
          
          <div className="stockist-content">
            <div className="stockist-benefits">
              <h3>Benefits of Becoming a Stockist</h3>
              
              <div className="benefits-grid">
                <div className="benefit-card">
                  <div className="benefit-icon">👥</div>
                  <h4>Expand Your Reach</h4>
                  <p>Attract new customers looking for adaptive clothing solutions</p>
                </div>
                
                <div className="benefit-card">
                  <div className="benefit-icon">💰</div>
                  <h4>Competitive Margins</h4>
                  <p>Enjoy attractive wholesale pricing and profit margins</p>
                </div>
                
                <div className="benefit-card">
                  <div className="benefit-icon">📚</div>
                  <h4>Full Training</h4>
                  <p>Comprehensive product training and support materials</p>
                </div>
                
                <div className="benefit-card">
                  <div className="benefit-icon">📈</div>
                  <h4>Marketing Support</h4>
                  <p>Co-marketing opportunities and promotional materials</p>
                </div>
              </div>
            </div>
            
            <div className="stockist-form-container">
              <div className="form-header">
                <h3>Become a Stockist</h3>
                <p>Fill out the form below and we'll contact you with more information</p>
              </div>
              
              <form className="stockist-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      placeholder="Your full name"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Your email address"
                      required
                    />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="business">Business Name *</label>
                    <input
                      type="text"
                      id="business"
                      name="business"
                      value={formData.business}
                      onChange={handleInputChange}
                      placeholder="Your business name"
                      required
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="location">Location *</label>
                    <input
                      type="text"
                      id="location"
                      name="location"
                      value={formData.location}
                      onChange={handleInputChange}
                      placeholder="City, State"
                      required
                    />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="type">Business Type *</label>
                  <select
                    id="type"
                    name="type"
                    value={formData.type}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select business type</option>
                    <option value="retail">Retail Store</option>
                    <option value="healthcare">Healthcare Provider</option>
                    <option value="therapy">Therapy Center</option>
                    <option value="hospital">Hospital/Clinic</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Tell us about your business *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Tell us about your business and why you're interested in stocking TSU..."
                    rows="4"
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="submit-stockist-btn">
                  Submit Application
                </button>
                
                <p className="form-note">
                  We'll review your application and contact you within 2-3 business days.
                </p>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2>Frequently Asked Questions</h2>
          
          <div className="faq-grid">
            <div className="faq-item">
              <h3>How does a virtual consultation work?</h3>
              <p>We schedule a video call to review your needs, recommend products, and answer questions about fit and features.</p>
            </div>
            
            <div className="faq-item">
              <h3>Can I try items at home?</h3>
              <p>Yes. We offer a home try-on option for select items so you can check fit and comfort before deciding.</p>
            </div>
            
            <div className="faq-item">
              <h3>Do you have a physical store?</h3>
              <p>We do not operate a physical store. Our services are online-first with virtual support and select partner stockists.</p>
            </div>
            
            <div className="faq-item">
              <h3>How do I become a stockist?</h3>
              <p>Complete the stockist form below and our team will reach out with next steps.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="final-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Experience TSU?</h2>
            <p>Discover the difference adaptive clothing can make with virtual guidance and easy online shopping.</p>
            <div className="cta-buttons">
              <a href="/shop" className="cta-btn primary">Shop Online</a>
              <a href="/contact" className="cta-btn secondary">Contact Us</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TryTSU;
